var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69693 4.02457C9.02858 2.65848 10.9714 2.65848 11.3031 4.02457C11.5173 4.90706 12.5284 5.32585 13.3039 4.85333C14.5043 4.12186 15.8781 5.49566 15.1467 6.69614C14.6742 7.47164 15.0929 8.48269 15.9754 8.69693C17.3415 9.02858 17.3415 10.9714 15.9754 11.3031C15.0929 11.5173 14.6742 12.5284 15.1467 13.3039C15.8781 14.5043 14.5043 15.8781 13.3039 15.1467C12.5284 14.6742 11.5173 15.0929 11.3031 15.9754C10.9714 17.3415 9.02858 17.3415 8.69693 15.9754C8.48269 15.0929 7.47164 14.6742 6.69614 15.1467C5.49566 15.8781 4.12186 14.5043 4.85333 13.3039C5.32585 12.5284 4.90706 11.5173 4.02457 11.3031C2.65848 10.9714 2.65848 9.02858 4.02457 8.69693C4.90706 8.48269 5.32585 7.47164 4.85333 6.69614C4.12186 5.49566 5.49566 4.12186 6.69614 4.85333C7.47164 5.32585 8.48269 4.90706 8.69693 4.02457Z",
    stroke: "#0000FF",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 10C12.3333 11.2887 11.2887 12.3333 10 12.3333C8.71134 12.3333 7.66667 11.2887 7.66667 10C7.66667 8.71134 8.71134 7.66667 10 7.66667C11.2887 7.66667 12.3333 8.71134 12.3333 10Z",
    stroke: "#262626",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settings-active.10b2742ede3814c1dad5b6de3a6d5c91.svg";
export { ForwardRef as ReactComponent };